(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ck-pdp-customer-proof"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('play', (event) => {
    if (!(event.target instanceof HTMLVideoElement) || !event.target.closest('.ckp-proof')) return;
    document.querySelectorAll('.ckp-proof video').forEach((video) => {
      if (video !== event.target) video.pause();
    });
  }, true);
  function ckInitReelCarousels() {
    document.querySelectorAll('[data-ck-reel-carousel]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const track = root.querySelector('.ckp-proof__videos');
      const prev = root.querySelector('[data-ck-reel-prev]');
      const next = root.querySelector('[data-ck-reel-next]');
      const controls = root.querySelector('.ckp-proof__controls');
      const update = () => {
        const overflow = track.scrollWidth - track.clientWidth;
        controls.hidden = overflow <= 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= overflow - 2;
      };
      const move = (direction) => {
        const card = track.querySelector('.ckp-proof__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('keydown', (event) => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
      });
      track.addEventListener('scroll', update, {passive: true});
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  }
  document.addEventListener('shopify:section:load', ckInitReelCarousels);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ckInitReelCarousels); else ckInitReelCarousels();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-sofa-story"] && !Shopify.designMode) return;
  try {
    
  function ckUpdateDimensions() {
    document.querySelectorAll('[data-ck-dimension-kind]').forEach((root) => {
      const values = Array.from(document.querySelectorAll('main variant-picker input:checked, main variant-picker select')).map((input) => input.value);
      let width, depth, choice;
      if (root.dataset.ckDimensionKind === 'primrose') {
        choice = values.find((value) => /^(280|330)cm x 195cm$/.test(value));
        if (!choice) return;
        width = choice.startsWith('280') ? '280' : '330'; depth = '195';
      } else if (root.dataset.ckDimensionKind === 'delray') {
        choice = values.find((value) => /^(Medium - 290cm|Large - 375cm|Left Right Corner 305cm)/.test(value));
        if (!choice) return;
        width = choice.startsWith('Medium') ? '290' : choice.startsWith('Large') ? '375' : '305';
        depth = choice.startsWith('Left') ? null : '220';
      } else return;
      root.querySelectorAll('[data-ck-dim-width]').forEach((el) => { el.textContent = width + ' cm'; });
      root.querySelectorAll('[data-ck-dim-depth]').forEach((el) => {
        if (depth) { el.textContent = depth + ' cm'; return; }
        const link = document.createElement('a'); link.href = '/pages/contact-us'; link.textContent = root.dataset.ckDepthHelpLabel; el.replaceChildren(link);
      });
      const selection = root.querySelector('[data-ck-dim-selection]');
      if (selection) selection.textContent = choice;
    });
  }
  document.addEventListener('variant:update', ckUpdateDimensions);
  document.addEventListener('shopify:section:load', ckUpdateDimensions);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ckUpdateDimensions); else ckUpdateDimensions();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
